import { FormDocument, FormDocumentAttachment } from '@/features/ui/DocumentsData/model/types';

import {
  AttachmentPayload,
  pushAttachment,
  addDocumentAttachments,
  toArray,
} from '@/shared/lib/helpers/payloadHelpers';

import { FormDataType } from '@/api/types';

export const collectAttachments = (formData: FormDataType, hasActualAddress: boolean): AttachmentPayload[] => {
  const attachments: AttachmentPayload[] = [];

  const photoCardAttachment = formData.photoCard as FormDocumentAttachment | undefined;
  pushAttachment(attachments, photoCardAttachment, 'photoCard');

  const rnokppAttachment = Array.isArray(formData.rnokppDoc)
    ? (formData.rnokppDoc[0] as FormDocumentAttachment | undefined)
    : (formData.rnokppDoc as FormDocumentAttachment | undefined);

  pushAttachment(attachments, rnokppAttachment, 'rnokppDoc');

  addDocumentAttachments(
    attachments,
    toArray<FormDocument>(formData.personPassportDocument as Nullable<FormDocument | FormDocument[]>),
    'personPassportDocument',
  );
  addDocumentAttachments(
    attachments,
    toArray<FormDocument>(formData.declaredDocRent as Nullable<FormDocument | FormDocument[]>),
    'declaredDocRent',
    'default',
    'REGISTRATION',
  );
  addDocumentAttachments(
    attachments,
    toArray<FormDocument>(formData.declaredNewDocRent as Nullable<FormDocument | FormDocument[]>),
    'declaredNewDocRent',
    'default',
    'REGISTRATION',
  );

  if (hasActualAddress) {
    addDocumentAttachments(
      attachments,
      toArray<FormDocument>(formData.actualPlaceOfResidence as Nullable<FormDocument | FormDocument[]>),
      'actualPlaceOfResidence',
      'default',
      'LIVING',
    );
  }

  addDocumentAttachments(
    attachments,
    toArray<FormDocument>(formData.confirmTechnicalConditionDocument as Nullable<FormDocument | FormDocument[]>),
    'confirmTechnicalConditionDocument',
  );

  toArray<FormDocument>(formData.additionalDocuments as Nullable<FormDocument | FormDocument[]>).forEach(
    (doc, index) => {
      pushAttachment(
        attachments,
        doc?.attachments,
        doc?.attachments?.formField ?? `additionalDocuments.${index}.attachments`,
        'additional',
        doc?.info as Record<string, unknown>,
      );
    },
  );

  return attachments;
};
